import React from 'react';
import { Location } from 'history';

import { RCCheckbox } from '@reverbdotcom/cadence/components';
import CoreLink from './core_link';
import { FilterOption } from './search_filters';
import { useUpdateUrl } from './with_update_url';
import { SelectFacetOptionCount, linkParams } from './select_facet_option';

interface IProps {
  option: FilterOption;
  trackInteraction: () => void;
  directLinkUrl?: string;
  location?: Location;
  nofollow?: boolean;
}

export function SelectFacetCheckbox({
  option,
  location = undefined,
  trackInteraction,
  directLinkUrl = undefined,
  nofollow = true,
}: IProps) {
  const { updateUrl } = useUpdateUrl();
  const zeroCount = option.count?.value === 0;

  const newUrl = directLinkUrl || (location && updateUrl({
    location: location,
    newParams: linkParams(option, true),
  }));

  function onClick() {
    trackInteraction();
  }

  const id = `${option.paramName}-${option.optionValue}`;
  return (
    <RCCheckbox
      id={id}
      key={`${id}--option${option.selected}`} // force a re-render of the checkbox when the selected state changes
      checked={option.selected}
      disabled={zeroCount}
      linkElement={(children) => (
        <CoreLink to={newUrl} onClick={onClick} rel={nofollow ? 'nofollow' : undefined}>
          {children}
        </CoreLink>
      )}
      label={(
        <>
          <span className="mr-space">{option.name}</span>
          <SelectFacetOptionCount option={option} />
        </>
      )}
    />
  );
}
